import usePlatformSettings from '../branding/usePlatformSettings';
import useAuth from '../auth/useAuth';
import { mediaUrl } from '../api';
import mvBildzeichen from '../assets/mv-bildzeichen.svg';
import mvLandessignet from '../assets/mv-landessignet.svg';

// Renders the admin-configured platform logo image, falling back to the
// Mecklenburg-Vorpommern Landessignet when no custom logo has been uploaded:
// the full "MV tut gut." signet, or - with variant="mark", for small square
// spots - the Bildzeichen alone. The official files are used unchanged
// (Markenhandbuch 2.1). The surrounding <Link>/button already carries the
// accessible name via aria-label, so the image itself stays decorative
// (alt="").
function BrandLogo({ variant = 'signet', fallback = 'b⁺' }) {
  const { logoUrl } = usePlatformSettings();
  const { preferences } = useAuth();

  // The signet belongs to the MV look; the classic theme keeps the platform's
  // own text mark when no logo has been uploaded.
  if (!logoUrl && preferences?.theme === 'classic') {
    return fallback;
  }

  const src = logoUrl
    ? mediaUrl(logoUrl)
    : variant === 'mark'
      ? mvBildzeichen
      : mvLandessignet;

  return (
    <img
      src={src}
      alt=""
      className="brand-logo-image"
    />
  );
}

export default BrandLogo;
